import { useContext } from 'react';

import { AppContextProps, AppStateContext } from '../providers/AppContext/AppContext';

export const useApp = (): AppContextProps => {
  const ctx = useContext(AppStateContext);
  if (!ctx) {
    throw new Error('Please configure AppContext before using "useApp()"');
  }
  return ctx;
};
